export default __webpack_public_path__ + "bfa0014abdccc545f0353fca8a15e7ea.png";